export default {
      id: "patient-usage",
      viewBox: "0 0 20 14",
      url: __webpack_public_path__ + "img/icons.ea6ea76b.svg#patient",
      toString: function () {
        return this.url;
      }
    }